export default __webpack_public_path__ + "static/media/School_3.12bc95b6.jpg";